module.exports = __webpack_public_path__ + "static/media/resume.af5b77b2.pdf";